import { Box, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { ChargeFormEntry } from '../../../../types';
import { formatMoney } from 'utils/helpers';
import { formatPercent } from 'views/orders/loans/utils';
import { sliceText } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    backgroundColor: theme.palette.background.default,
    padding: '0.5rem',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  textContainer: {
    display: 'grid',
    gridTemplateColumns: 'minmax(5rem, 1fr) 3rem minmax(2rem, 5rem)',
    columnGap: theme.spacing(1),
    width: '100%',
  },
  text: {
    fontSize: '0.8rem',
  },
}));

type Props = {
  charge: ChargeFormEntry;
  onOpenSplitModal: () => void;
};

export const PayeeField: FC<Props> = ({ charge, onOpenSplitModal }) => {
  const classes = useStyles();

  let content: React.ReactNode = (
    <Typography className={classes.text}>
      {charge.payees.length ? sliceText(charge.payees[0].name, 30) : 'Select Payee'}
    </Typography>
  );

  if (charge.payees.length > 1) {
    content = (
      <Box className={classes.textContainer}>
        {charge.payees.map(({ name, amount, percent }) => (
          <React.Fragment key={`${name}-${amount}-${percent}`}>
            <Typography className={classes.text}>
              {name.length > 30 ? name.slice(0, 30).concat('...') : name}
            </Typography>

            <Typography className={classes.text} style={{ justifySelf: 'flex-end' }}>
              {percent !== 1 && formatPercent(percent, 2)}
            </Typography>
            <Typography
              className={classes.text}
              style={{ fontWeight: '500', color: 'black', justifySelf: 'flex-end' }}
            >
              {percent !== 1 && formatMoney(amount)}
            </Typography>
          </React.Fragment>
        ))}
      </Box>
    );
  }

  return (
    <Tooltip
      title={
        charge.accounting_id
          ? 'Click this field to open a selection window where you can choose the parties involved'
          : 'Charge must be saved before selecting parties'
      }
    >
      <Box
        className={classes.inputContainer}
        style={{
          height: charge.payees.length <= 1 ? '2rem' : 'auto',
          cursor: charge.accounting_id ? 'pointer' : 'not-allowed',
        }}
        onClick={() => charge.accounting_id && onOpenSplitModal()}
      >
        {content}
      </Box>
    </Tooltip>
  );
};
